// MBTI 검사를 위한 질문 데이터
// 각 질문마다 id, 질문 텍스트, MBTI 차원(E-I, S-N, T-F, J-P), 방향을 포함

export const questions = [
  // 기존 E-I 질문들...
  {
    id: 1,
    text: "파티나 모임에서 새로운 사람들과 대화하는 것이 즐겁다.",
    dimension: "E-I",
    direction: "E"
  },
  {
    id: 2,
    text: "혼자 시간을 보내는 것보다 다른 사람들과 함께 있는 것이 더 좋다.",
    dimension: "E-I",
    direction: "E"
  },
  {
    id: 3,
    text: "새로운 사람들과 만날 때 대화를 먼저 시작하는 편이다.",
    dimension: "E-I",
    direction: "E"
  },
  {
    id: 4,
    text: "조용한 환경보다는 활기찬 환경에서 에너지를 얻는다.",
    dimension: "E-I",
    direction: "E"
  },
  {
    id: 5,
    text: "깊이 생각하기 전에 말을 하는 경향이 있다.",
    dimension: "E-I",
    direction: "E"
  },
  {
    id: 6,
    text: "책을 읽거나 생각에 몰입하는 시간을 자주 갖는다.",
    dimension: "E-I",
    direction: "I"
  },
  {
    id: 7,
    text: "사람이 많은 모임 후에는 혼자만의 시간이 필요하다.",
    dimension: "E-I",
    direction: "I"
  },
  // 기존 S-N 질문들...
  {
    id: 8,
    text: "실제 경험과 사실에 근거하여 판단하는 것을 선호한다.",
    dimension: "S-N",
    direction: "S"
  },
  {
    id: 9,
    text: "세부 사항에 주의를 기울이는 편이다.",
    dimension: "S-N",
    direction: "S"
  },
  {
    id: 10,
    text: "미래의 가능성보다 현재의 실제 상황에 집중한다.",
    dimension: "S-N",
    direction: "S"
  },
  {
    id: 11,
    text: "추상적인 개념보다 구체적인 사실을 선호한다.",
    dimension: "S-N",
    direction: "S"
  },
  {
    id: 12,
    text: "새로운 가능성을 상상하는 것을 즐긴다.",
    dimension: "S-N",
    direction: "N"
  },
  {
    id: 13,
    text: "패턴과 연결성을 찾는 것을 좋아한다.",
    dimension: "S-N",
    direction: "N"
  },
  {
    id: 14,
    text: "아이디어와 개념에 대해 생각하는 것을 즐긴다.",
    dimension: "S-N",
    direction: "N"
  },
  
  // T-F 차원 질문들 (추가)
  {
    id: 15,
    text: "의사결정을 할 때 논리와 사실에 기반하여 판단한다.",
    dimension: "T-F",
    direction: "T"
  },
  {
    id: 16,
    text: "감정보다 이성을 더 중요하게 생각한다.",
    dimension: "T-F",
    direction: "T"
  },
  {
    id: 17,
    text: "비판을 할 때 솔직하고 직접적인 편이다.",
    dimension: "T-F",
    direction: "T"
  },
  {
    id: 18,
    text: "논쟁에서 이기는 것이 상대방의 감정을 배려하는 것보다 중요하다.",
    dimension: "T-F",
    direction: "T"
  },
  {
    id: 19,
    text: "효율성을 중시하며 객관적으로 문제를 해결하려 한다.",
    dimension: "T-F",
    direction: "T"
  },
  {
    id: 20,
    text: "다른 사람의 감정을 고려하여 결정을 내리는 편이다.",
    dimension: "T-F",
    direction: "F"
  },
  {
    id: 21,
    text: "조화로운 분위기를 유지하는 것이 중요하다고 생각한다.",
    dimension: "T-F",
    direction: "F"
  },
  {
    id: 22,
    text: "다른 사람을 돕는 일에서 만족감을 느낀다.",
    dimension: "T-F",
    direction: "F"
  },
  {
    id: 23,
    text: "갈등 상황에서 타협점을 찾으려고 노력한다.",
    dimension: "T-F",
    direction: "F"
  },
  {
    id: 24,
    text: "사람들의 감정적 필요에 민감하게 반응한다.",
    dimension: "T-F",
    direction: "F"
  },
  
  // J-P 차원 질문들 (추가)
  {
    id: 25,
    text: "계획을 세우고 그에 따라 생활하는 것을 좋아한다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 26,
    text: "일을 시작하기 전에 미리 계획을 세우는 편이다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 27,
    text: "마감 기한보다 여유 있게 과제를 완료하는 편이다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 28,
    text: "일상적인 규칙과 일정을 따르는 것이 편안하다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 29,
    text: "결정을 내리는 것을 미루지 않고 빨리 처리한다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 30,
    text: "정돈된 환경에서 일하는 것을 선호한다.",
    dimension: "J-P",
    direction: "J"
  },
  {
    id: 31,
    text: "계획에 변화가 생겨도 유연하게 대처할 수 있다.",
    dimension: "J-P",
    direction: "P"
  },
  {
    id: 32,
    text: "즉흥적으로 결정을 내리는 것을 편안하게 느낀다.",
    dimension: "J-P",
    direction: "P"
  },
  {
    id: 33,
    text: "계획보다 그때그때 상황에 맞게 행동하는 것을 선호한다.",
    dimension: "J-P",
    direction: "P"
  },
  {
    id: 34,
    text: "마감 기한이 다가와야 일에 집중하는 편이다.",
    dimension: "J-P",
    direction: "P"
  },
  {
    id: 35,
    text: "새로운 경험과 변화를 추구한다.",
    dimension: "J-P",
    direction: "P"
  }
];